import { isComponentReactFragment } from '../../../utils/react'
import { Field } from '../../Field'

function FormField({ Component = Field, children, ...restProps }) {
  return (
    <Component {...(isComponentReactFragment(Component) ? null : restProps)}>
      {children}
    </Component>
  )
}

export default FormField
